<template>
        <span v-if="!editable">{{value}}</span>
        <input v-else v-bind:value="value"
               v-on:input="$emit('input', moment.utc($event.target.value))"
               @beforeinput="isInteger">
</template>

<script>
        export default {
                name: "EditableNumber",
                props: {editable : Boolean,
                        value: Number},
                //Won't work in firefox until https://bugzilla.mozilla.org/show_bug.cgi?id=1609291 is closed
                isInteger(event) {
                        let charCode = event.data;

                        if (event.data === "1") {
                                return
                        } else {

                        }
                }
        }
</script>

<style scoped>
</style>
